import { Warning as WarningIcon } from '@mui/icons-material';
import { Box, Checkbox, Tooltip, Typography } from '@mui/material';

import type { NormalizedModuleItem, SelectionKey } from '../../types/merge-customization';

import { PatientSourceChip } from './PatientSourceChip';

interface ModuleItemProps {
  item: NormalizedModuleItem;
  isSelected: boolean;
  isDuplicate: boolean;
  onToggle: (key: SelectionKey) => void;
  patientColor: string;
  /** Whether to show the patient source chip (default true) */
  showPatientChip?: boolean;
}

export function ModuleItem({
  item,
  isSelected,
  isDuplicate,
  onToggle,
  patientColor,
  showPatientChip = true,
}: ModuleItemProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        py: 0.75,
        px: 1,
        borderRadius: 1,
        '&:hover': { backgroundColor: 'grey.50' },
      }}
    >
      <Checkbox
        size="small"
        checked={isSelected}
        onChange={() => onToggle(item.selectionKey)}
        aria-label={`${isSelected ? 'Deselect' : 'Select'} ${item.displayLabel} from ${item.patientName}`}
        sx={{ p: 0.5 }}
      />
      <Typography variant="body2" sx={{ flex: 1, minWidth: 0 }} noWrap>
        {item.displayLabel}
      </Typography>
      {showPatientChip && (
        <PatientSourceChip
          name={item.patientName}
          isPrimary={item.isPrimary}
          color={patientColor}
        />
      )}
      {isDuplicate && (
        <Tooltip title="This item appears in multiple patient records" arrow>
          <WarningIcon fontSize="small" sx={{ color: 'warning.main', ml: 0.5 }} />
        </Tooltip>
      )}
    </Box>
  );
}
